import { render, staticRenderFns } from "./bankCardAdd.vue?vue&type=template&id=567f7b32&scoped=true"
import script from "./bankCardAdd.vue?vue&type=script&lang=js"
export * from "./bankCardAdd.vue?vue&type=script&lang=js"
import style0 from "./bankCardAdd.vue?vue&type=style&index=0&id=567f7b32&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "567f7b32",
  null
  
)

export default component.exports